export const staticConfig = (() => {
  return {
    env: import.meta.env.VITE_ENV,
    tenantId: import.meta.env.VITE_ADMIN_TENANT_ID,
    firebase: {
      config: {
        apiKey: import.meta.env.VITE_FIRESTORE_API_KEY,
        authDomain: import.meta.env.VITE_FIRESTORE_AUTH_DOMAIN,
        databaseURL: import.meta.env.VITE_FIRESTORE_DATABASE_URL,
        projectId: import.meta.env.VITE_FIRESTORE_PROJECT_ID,
        storageBucket: import.meta.env.VITE_FIRESTORE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_FIRESTORE_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FIRESTORE_APP_ID,
      },
    },
  };
})();
